/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AccountRouteImport } from './routes/account'
import { Route as CleanersRouteImport } from './routes/cleaners'
import { Route as ClientsRouteImport } from './routes/clients'
import { Route as ConfirmEmailRouteImport } from './routes/confirm-email'
import { Route as CreateAccountRouteImport } from './routes/create-account'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as InspectionsRouteImport } from './routes/inspections'
import { Route as InventoryRouteImport } from './routes/inventory'
import { Route as InvoicesRouteImport } from './routes/invoices'
import { Route as JobsRouteImport } from './routes/jobs'
import { Route as MessagesRouteImport } from './routes/messages'
import { Route as OrdersRouteImport } from './routes/orders'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ScheduleRouteImport } from './routes/schedule'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SetupRouteImport } from './routes/setup'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as AcceptInvitationIdRouteImport } from './routes/accept-invitation.$id'
import { Route as CleanersCleanerIdRouteImport } from './routes/cleaners.$cleanerId'
import { Route as ClientsClientIdRouteImport } from './routes/clients.$clientId'
import { Route as InvoicesInvoiceIdRouteImport } from './routes/invoices.$invoiceId'
import { Route as JobsJobIdRouteImport } from './routes/jobs.$jobId'
import { Route as OauthConsentRouteImport } from './routes/oauth.consent'
import { Route as OauthErrorRouteImport } from './routes/oauth.error'
import { Route as OrdersOrderIdRouteImport } from './routes/orders.$orderId'
import { Route as SettingsBusinessRouteImport } from './routes/settings.business'
import { Route as SettingsDataDictionaryRouteImport } from './routes/settings.data-dictionary'
import { Route as SettingsImportRouteImport } from './routes/settings.import'
import { Route as SettingsMcpRouteImport } from './routes/settings.mcp'
import { Route as SettingsSystemRouteImport } from './routes/settings.system'
import { Route as SettingsUsersRouteImport } from './routes/settings.users'
import { Route as SettingsWebhooksRouteImport } from './routes/settings.webhooks'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const CleanersRoute = CleanersRouteImport.update({
  id: '/cleaners',
  path: '/cleaners',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsRoute = ClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfirmEmailRoute = ConfirmEmailRouteImport.update({
  id: '/confirm-email',
  path: '/confirm-email',
  getParentRoute: () => rootRouteImport,
} as any)
const CreateAccountRoute = CreateAccountRouteImport.update({
  id: '/create-account',
  path: '/create-account',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const InspectionsRoute = InspectionsRouteImport.update({
  id: '/inspections',
  path: '/inspections',
  getParentRoute: () => rootRouteImport,
} as any)
const InventoryRoute = InventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesRoute = InvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => rootRouteImport,
} as any)
const JobsRoute = JobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => rootRouteImport,
} as any)
const MessagesRoute = MessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersRoute = OrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ScheduleRoute = ScheduleRouteImport.update({
  id: '/schedule',
  path: '/schedule',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SetupRoute = SetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInvitationIdRoute = AcceptInvitationIdRouteImport.update({
  id: '/accept-invitation/$id',
  path: '/accept-invitation/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const CleanersCleanerIdRoute = CleanersCleanerIdRouteImport.update({
  id: '/$cleanerId',
  path: '/$cleanerId',
  getParentRoute: () => CleanersRoute,
} as any)
const ClientsClientIdRoute = ClientsClientIdRouteImport.update({
  id: '/$clientId',
  path: '/$clientId',
  getParentRoute: () => ClientsRoute,
} as any)
const InvoicesInvoiceIdRoute = InvoicesInvoiceIdRouteImport.update({
  id: '/$invoiceId',
  path: '/$invoiceId',
  getParentRoute: () => InvoicesRoute,
} as any)
const JobsJobIdRoute = JobsJobIdRouteImport.update({
  id: '/$jobId',
  path: '/$jobId',
  getParentRoute: () => JobsRoute,
} as any)
const OauthConsentRoute = OauthConsentRouteImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthErrorRoute = OauthErrorRouteImport.update({
  id: '/oauth/error',
  path: '/oauth/error',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersOrderIdRoute = OrdersOrderIdRouteImport.update({
  id: '/$orderId',
  path: '/$orderId',
  getParentRoute: () => OrdersRoute,
} as any)
const SettingsBusinessRoute = SettingsBusinessRouteImport.update({
  id: '/business',
  path: '/business',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsDataDictionaryRoute = SettingsDataDictionaryRouteImport.update({
  id: '/data-dictionary',
  path: '/data-dictionary',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsImportRoute = SettingsImportRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsMcpRoute = SettingsMcpRouteImport.update({
  id: '/mcp',
  path: '/mcp',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSystemRoute = SettingsSystemRouteImport.update({
  id: '/system',
  path: '/system',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsUsersRoute = SettingsUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsWebhooksRoute = SettingsWebhooksRouteImport.update({
  id: '/webhooks',
  path: '/webhooks',
  getParentRoute: () => SettingsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/cleaners': typeof CleanersRouteWithChildren
  '/clients': typeof ClientsRouteWithChildren
  '/confirm-email': typeof ConfirmEmailRoute
  '/create-account': typeof CreateAccountRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/inspections': typeof InspectionsRoute
  '/inventory': typeof InventoryRoute
  '/invoices': typeof InvoicesRouteWithChildren
  '/jobs': typeof JobsRouteWithChildren
  '/messages': typeof MessagesRoute
  '/orders': typeof OrdersRouteWithChildren
  '/reset-password': typeof ResetPasswordRoute
  '/schedule': typeof ScheduleRoute
  '/settings': typeof SettingsRouteWithChildren
  '/setup': typeof SetupRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/accept-invitation/$id': typeof AcceptInvitationIdRoute
  '/cleaners/$cleanerId': typeof CleanersCleanerIdRoute
  '/clients/$clientId': typeof ClientsClientIdRoute
  '/invoices/$invoiceId': typeof InvoicesInvoiceIdRoute
  '/jobs/$jobId': typeof JobsJobIdRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/oauth/error': typeof OauthErrorRoute
  '/orders/$orderId': typeof OrdersOrderIdRoute
  '/settings/business': typeof SettingsBusinessRoute
  '/settings/data-dictionary': typeof SettingsDataDictionaryRoute
  '/settings/import': typeof SettingsImportRoute
  '/settings/mcp': typeof SettingsMcpRoute
  '/settings/system': typeof SettingsSystemRoute
  '/settings/users': typeof SettingsUsersRoute
  '/settings/webhooks': typeof SettingsWebhooksRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/cleaners': typeof CleanersRouteWithChildren
  '/clients': typeof ClientsRouteWithChildren
  '/confirm-email': typeof ConfirmEmailRoute
  '/create-account': typeof CreateAccountRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/inspections': typeof InspectionsRoute
  '/inventory': typeof InventoryRoute
  '/invoices': typeof InvoicesRouteWithChildren
  '/jobs': typeof JobsRouteWithChildren
  '/messages': typeof MessagesRoute
  '/orders': typeof OrdersRouteWithChildren
  '/reset-password': typeof ResetPasswordRoute
  '/schedule': typeof ScheduleRoute
  '/settings': typeof SettingsRouteWithChildren
  '/setup': typeof SetupRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/accept-invitation/$id': typeof AcceptInvitationIdRoute
  '/cleaners/$cleanerId': typeof CleanersCleanerIdRoute
  '/clients/$clientId': typeof ClientsClientIdRoute
  '/invoices/$invoiceId': typeof InvoicesInvoiceIdRoute
  '/jobs/$jobId': typeof JobsJobIdRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/oauth/error': typeof OauthErrorRoute
  '/orders/$orderId': typeof OrdersOrderIdRoute
  '/settings/business': typeof SettingsBusinessRoute
  '/settings/data-dictionary': typeof SettingsDataDictionaryRoute
  '/settings/import': typeof SettingsImportRoute
  '/settings/mcp': typeof SettingsMcpRoute
  '/settings/system': typeof SettingsSystemRoute
  '/settings/users': typeof SettingsUsersRoute
  '/settings/webhooks': typeof SettingsWebhooksRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/cleaners': typeof CleanersRouteWithChildren
  '/clients': typeof ClientsRouteWithChildren
  '/confirm-email': typeof ConfirmEmailRoute
  '/create-account': typeof CreateAccountRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/inspections': typeof InspectionsRoute
  '/inventory': typeof InventoryRoute
  '/invoices': typeof InvoicesRouteWithChildren
  '/jobs': typeof JobsRouteWithChildren
  '/messages': typeof MessagesRoute
  '/orders': typeof OrdersRouteWithChildren
  '/reset-password': typeof ResetPasswordRoute
  '/schedule': typeof ScheduleRoute
  '/settings': typeof SettingsRouteWithChildren
  '/setup': typeof SetupRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/accept-invitation/$id': typeof AcceptInvitationIdRoute
  '/cleaners/$cleanerId': typeof CleanersCleanerIdRoute
  '/clients/$clientId': typeof ClientsClientIdRoute
  '/invoices/$invoiceId': typeof InvoicesInvoiceIdRoute
  '/jobs/$jobId': typeof JobsJobIdRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/oauth/error': typeof OauthErrorRoute
  '/orders/$orderId': typeof OrdersOrderIdRoute
  '/settings/business': typeof SettingsBusinessRoute
  '/settings/data-dictionary': typeof SettingsDataDictionaryRoute
  '/settings/import': typeof SettingsImportRoute
  '/settings/mcp': typeof SettingsMcpRoute
  '/settings/system': typeof SettingsSystemRoute
  '/settings/users': typeof SettingsUsersRoute
  '/settings/webhooks': typeof SettingsWebhooksRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/cleaners'
    | '/clients'
    | '/confirm-email'
    | '/create-account'
    | '/forgot-password'
    | '/inspections'
    | '/inventory'
    | '/invoices'
    | '/jobs'
    | '/messages'
    | '/orders'
    | '/reset-password'
    | '/schedule'
    | '/settings'
    | '/setup'
    | '/sign-in'
    | '/sign-up'
    | '/accept-invitation/$id'
    | '/cleaners/$cleanerId'
    | '/clients/$clientId'
    | '/invoices/$invoiceId'
    | '/jobs/$jobId'
    | '/oauth/consent'
    | '/oauth/error'
    | '/orders/$orderId'
    | '/settings/business'
    | '/settings/data-dictionary'
    | '/settings/import'
    | '/settings/mcp'
    | '/settings/system'
    | '/settings/users'
    | '/settings/webhooks'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account'
    | '/cleaners'
    | '/clients'
    | '/confirm-email'
    | '/create-account'
    | '/forgot-password'
    | '/inspections'
    | '/inventory'
    | '/invoices'
    | '/jobs'
    | '/messages'
    | '/orders'
    | '/reset-password'
    | '/schedule'
    | '/settings'
    | '/setup'
    | '/sign-in'
    | '/sign-up'
    | '/accept-invitation/$id'
    | '/cleaners/$cleanerId'
    | '/clients/$clientId'
    | '/invoices/$invoiceId'
    | '/jobs/$jobId'
    | '/oauth/consent'
    | '/oauth/error'
    | '/orders/$orderId'
    | '/settings/business'
    | '/settings/data-dictionary'
    | '/settings/import'
    | '/settings/mcp'
    | '/settings/system'
    | '/settings/users'
    | '/settings/webhooks'
  id:
    | '__root__'
    | '/'
    | '/account'
    | '/cleaners'
    | '/clients'
    | '/confirm-email'
    | '/create-account'
    | '/forgot-password'
    | '/inspections'
    | '/inventory'
    | '/invoices'
    | '/jobs'
    | '/messages'
    | '/orders'
    | '/reset-password'
    | '/schedule'
    | '/settings'
    | '/setup'
    | '/sign-in'
    | '/sign-up'
    | '/accept-invitation/$id'
    | '/cleaners/$cleanerId'
    | '/clients/$clientId'
    | '/invoices/$invoiceId'
    | '/jobs/$jobId'
    | '/oauth/consent'
    | '/oauth/error'
    | '/orders/$orderId'
    | '/settings/business'
    | '/settings/data-dictionary'
    | '/settings/import'
    | '/settings/mcp'
    | '/settings/system'
    | '/settings/users'
    | '/settings/webhooks'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountRoute: typeof AccountRoute
  CleanersRoute: typeof CleanersRouteWithChildren
  ClientsRoute: typeof ClientsRouteWithChildren
  ConfirmEmailRoute: typeof ConfirmEmailRoute
  CreateAccountRoute: typeof CreateAccountRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  InspectionsRoute: typeof InspectionsRoute
  InventoryRoute: typeof InventoryRoute
  InvoicesRoute: typeof InvoicesRouteWithChildren
  JobsRoute: typeof JobsRouteWithChildren
  MessagesRoute: typeof MessagesRoute
  OrdersRoute: typeof OrdersRouteWithChildren
  ResetPasswordRoute: typeof ResetPasswordRoute
  ScheduleRoute: typeof ScheduleRoute
  SettingsRoute: typeof SettingsRouteWithChildren
  SetupRoute: typeof SetupRoute
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
  AcceptInvitationIdRoute: typeof AcceptInvitationIdRoute
  OauthConsentRoute: typeof OauthConsentRoute
  OauthErrorRoute: typeof OauthErrorRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cleaners': {
      id: '/cleaners'
      path: '/cleaners'
      fullPath: '/cleaners'
      preLoaderRoute: typeof CleanersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients': {
      id: '/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof ClientsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/confirm-email': {
      id: '/confirm-email'
      path: '/confirm-email'
      fullPath: '/confirm-email'
      preLoaderRoute: typeof ConfirmEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/create-account': {
      id: '/create-account'
      path: '/create-account'
      fullPath: '/create-account'
      preLoaderRoute: typeof CreateAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inspections': {
      id: '/inspections'
      path: '/inspections'
      fullPath: '/inspections'
      preLoaderRoute: typeof InspectionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory': {
      id: '/inventory'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof InventoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices': {
      id: '/invoices'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof InvoicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jobs': {
      id: '/jobs'
      path: '/jobs'
      fullPath: '/jobs'
      preLoaderRoute: typeof JobsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/messages': {
      id: '/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof MessagesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders': {
      id: '/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof OrdersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/schedule': {
      id: '/schedule'
      path: '/schedule'
      fullPath: '/schedule'
      preLoaderRoute: typeof ScheduleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup': {
      id: '/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof SetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invitation/$id': {
      id: '/accept-invitation/$id'
      path: '/accept-invitation/$id'
      fullPath: '/accept-invitation/$id'
      preLoaderRoute: typeof AcceptInvitationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cleaners/$cleanerId': {
      id: '/cleaners/$cleanerId'
      path: '/$cleanerId'
      fullPath: '/cleaners/$cleanerId'
      preLoaderRoute: typeof CleanersCleanerIdRouteImport
      parentRoute: typeof CleanersRoute
    }
    '/clients/$clientId': {
      id: '/clients/$clientId'
      path: '/$clientId'
      fullPath: '/clients/$clientId'
      preLoaderRoute: typeof ClientsClientIdRouteImport
      parentRoute: typeof ClientsRoute
    }
    '/invoices/$invoiceId': {
      id: '/invoices/$invoiceId'
      path: '/$invoiceId'
      fullPath: '/invoices/$invoiceId'
      preLoaderRoute: typeof InvoicesInvoiceIdRouteImport
      parentRoute: typeof InvoicesRoute
    }
    '/jobs/$jobId': {
      id: '/jobs/$jobId'
      path: '/$jobId'
      fullPath: '/jobs/$jobId'
      preLoaderRoute: typeof JobsJobIdRouteImport
      parentRoute: typeof JobsRoute
    }
    '/oauth/consent': {
      id: '/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof OauthConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/error': {
      id: '/oauth/error'
      path: '/oauth/error'
      fullPath: '/oauth/error'
      preLoaderRoute: typeof OauthErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/$orderId': {
      id: '/orders/$orderId'
      path: '/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof OrdersOrderIdRouteImport
      parentRoute: typeof OrdersRoute
    }
    '/settings/business': {
      id: '/settings/business'
      path: '/business'
      fullPath: '/settings/business'
      preLoaderRoute: typeof SettingsBusinessRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/data-dictionary': {
      id: '/settings/data-dictionary'
      path: '/data-dictionary'
      fullPath: '/settings/data-dictionary'
      preLoaderRoute: typeof SettingsDataDictionaryRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/import': {
      id: '/settings/import'
      path: '/import'
      fullPath: '/settings/import'
      preLoaderRoute: typeof SettingsImportRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/mcp': {
      id: '/settings/mcp'
      path: '/mcp'
      fullPath: '/settings/mcp'
      preLoaderRoute: typeof SettingsMcpRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/system': {
      id: '/settings/system'
      path: '/system'
      fullPath: '/settings/system'
      preLoaderRoute: typeof SettingsSystemRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/users': {
      id: '/settings/users'
      path: '/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof SettingsUsersRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/webhooks': {
      id: '/settings/webhooks'
      path: '/webhooks'
      fullPath: '/settings/webhooks'
      preLoaderRoute: typeof SettingsWebhooksRouteImport
      parentRoute: typeof SettingsRoute
    }
  }
}

interface CleanersRouteChildren {
  CleanersCleanerIdRoute: typeof CleanersCleanerIdRoute
}

const CleanersRouteChildren: CleanersRouteChildren = {
  CleanersCleanerIdRoute: CleanersCleanerIdRoute,
}

const CleanersRouteWithChildren = CleanersRoute._addFileChildren(
  CleanersRouteChildren,
)

interface ClientsRouteChildren {
  ClientsClientIdRoute: typeof ClientsClientIdRoute
}

const ClientsRouteChildren: ClientsRouteChildren = {
  ClientsClientIdRoute: ClientsClientIdRoute,
}

const ClientsRouteWithChildren =
  ClientsRoute._addFileChildren(ClientsRouteChildren)

interface InvoicesRouteChildren {
  InvoicesInvoiceIdRoute: typeof InvoicesInvoiceIdRoute
}

const InvoicesRouteChildren: InvoicesRouteChildren = {
  InvoicesInvoiceIdRoute: InvoicesInvoiceIdRoute,
}

const InvoicesRouteWithChildren = InvoicesRoute._addFileChildren(
  InvoicesRouteChildren,
)

interface JobsRouteChildren {
  JobsJobIdRoute: typeof JobsJobIdRoute
}

const JobsRouteChildren: JobsRouteChildren = {
  JobsJobIdRoute: JobsJobIdRoute,
}

const JobsRouteWithChildren = JobsRoute._addFileChildren(JobsRouteChildren)

interface OrdersRouteChildren {
  OrdersOrderIdRoute: typeof OrdersOrderIdRoute
}

const OrdersRouteChildren: OrdersRouteChildren = {
  OrdersOrderIdRoute: OrdersOrderIdRoute,
}

const OrdersRouteWithChildren =
  OrdersRoute._addFileChildren(OrdersRouteChildren)

interface SettingsRouteChildren {
  SettingsBusinessRoute: typeof SettingsBusinessRoute
  SettingsDataDictionaryRoute: typeof SettingsDataDictionaryRoute
  SettingsImportRoute: typeof SettingsImportRoute
  SettingsMcpRoute: typeof SettingsMcpRoute
  SettingsSystemRoute: typeof SettingsSystemRoute
  SettingsUsersRoute: typeof SettingsUsersRoute
  SettingsWebhooksRoute: typeof SettingsWebhooksRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsBusinessRoute: SettingsBusinessRoute,
  SettingsDataDictionaryRoute: SettingsDataDictionaryRoute,
  SettingsImportRoute: SettingsImportRoute,
  SettingsMcpRoute: SettingsMcpRoute,
  SettingsSystemRoute: SettingsSystemRoute,
  SettingsUsersRoute: SettingsUsersRoute,
  SettingsWebhooksRoute: SettingsWebhooksRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountRoute: AccountRoute,
  CleanersRoute: CleanersRouteWithChildren,
  ClientsRoute: ClientsRouteWithChildren,
  ConfirmEmailRoute: ConfirmEmailRoute,
  CreateAccountRoute: CreateAccountRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  InspectionsRoute: InspectionsRoute,
  InventoryRoute: InventoryRoute,
  InvoicesRoute: InvoicesRouteWithChildren,
  JobsRoute: JobsRouteWithChildren,
  MessagesRoute: MessagesRoute,
  OrdersRoute: OrdersRouteWithChildren,
  ResetPasswordRoute: ResetPasswordRoute,
  ScheduleRoute: ScheduleRoute,
  SettingsRoute: SettingsRouteWithChildren,
  SetupRoute: SetupRoute,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
  AcceptInvitationIdRoute: AcceptInvitationIdRoute,
  OauthConsentRoute: OauthConsentRoute,
  OauthErrorRoute: OauthErrorRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
